import * as z from 'zod';

import { domainQueryLinkerSchemaWithExData } from '@/_pages/domains/shared/schemas/domain-query-linker-schema';
import { fileQuerySchema } from '@/_schemas/file';
import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';
import { phoneNumberQuerySchema } from '@/_schemas/phone-numbers';

import { registrarQueryLinkerSchema } from './registrar-query-linker-schema';

export const registrarQuerySchema = z.object({
  ...registrarQueryLinkerSchema.shape,
  url: z.url().nullable(),
  notes: z.string().nullable(),
  logo: z.array(fileQuerySchema).nullish(),
  phone_numbers: z.array(phoneNumberQuerySchema).nullish(),
  domains: z.array(domainQueryLinkerSchemaWithExData).nullable(),
  domains_count: z.number(),
});

export type RegistrarQuerySchema = z.infer<typeof registrarQuerySchema>;

export const registrarQueryAllSchema = paginatedResponseSchema(registrarQuerySchema);

export type RegistrarQueryAllSchema = z.infer<typeof registrarQueryAllSchema>;
